<template>
  <div>
    <Nav :authenticated="authFlag" />

    <header class="mt-5">
      <div class="container">
        <div class="row justify-content-center text-center">
          <div class="col-12 col-md-6">
            <h1 class>Pricing</h1>
            <p
              class="mb-0"
            >Use the power of Infodemics with the following easy pricing.</p>
          </div>
        </div>
      </div>
    </header>

    <section class="pricing">
      <div class="container">
        <div class="card-deck no-gutter mb-3">
          <div class="card pricing-card pricing-card--features mb-4 box-shadow">
            <div class="card-body">
              <p class="pricing-card__title text-clear">Features</p>
              <h1 class="card-title pricing-card__cost pb-3 text-clear">$0</h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li class="list-divider">Location</li>
                <li>Pin a Location</li>
                <li>Modify a Location</li>
                <li class="list-divider">Circle</li>
                <li>Join a Circle</li>
                <li>Start a Circle</li>
                <li>Create a Circle</li>
                <li class="list-divider">Media</li>
                <li>SMS</li>
                <li>Email</li>
                <li>IVR</li>
                <li>USSD</li>
                <li>Disbursement</li>
                <li class="list-divider">Other Services</li>
                <li>Volunteer</li>
                <li>Health Center/Medical</li>
                <li>Local Leaders</li>
              </ul>
            </div>
          </div>

          <div class="card pricing-card mb-4 box-shadow">
            <div class="card-body">
              <p class="pricing-card__title">Petri</p>
              <h1 class="card-title pricing-card__cost pb-3">
                Free
              </h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li class="list-divider">Location</li>
                <li class="checked">Pin a Location</li>
                <li class="checked">Modify a Location</li>

                <li class="list-divider">Circle</li>
                <li class="checked">Join a Circle</li>
                <li class="unchecked">Start a Circle</li>
                <li class="unchecked">Create a Campaign</li>

                <li class="list-divider">Media</li>
                <li class="unchecked">SMS</li>
                <li class="checked">Email</li>
                <li class="unchecked">IVR</li>
                <li class="unchecked">USSD</li>
                <li class="unchecked">Disbursement</li>

                <li class="list-divider">Other Services</li>
                <li class="checked">Volunteer</li>
                <li class="unchecked">Health Center/Medical</li>
                <li class="unchecked">Local Leaders</li>
              </ul>
              <div class="text-center">
                <a href="" class="btn btn-primary btn-lg d-inline">Get Started</a>
              </div>
            </div>
          </div>

          <div class="card pricing-card mb-4 box-shadow">
            <div class="card-body">
              <p class="pricing-card__title">Beaker</p>
              <h1 class="card-title pricing-card__cost pb-3">
                £10
                <small class="text-muted">/ mo</small>
              </h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li class="list-divider">Location</li>
                <li class="checked">Pin a Location</li>
                <li class="checked">Modify a Location</li>

                <li class="list-divider">Circle</li>
                <li class="checked">Join a Circle</li>
                <li class="checked">Start a Circle</li>
                <li class="unchecked">Create a Campaign</li>

                <li class="list-divider">Media</li>
                <li class="checked">SMS</li>
                <li class="checked">Email</li>
                <li class="unchecked">IVR</li>
                <li class="unchecked">USSD</li>
                <li class="unchecked">Disbursement</li>

                <li class="list-divider">Other Services</li>
                <li class="checked">Volunteer</li>
                <li class="checked">Health Center/Medical</li>
                <li class="unchecked">Local Leaders</li>
              </ul>
              <div class="text-center">
                <a href="" class="btn btn-primary btn-lg d-inline">Get Started</a>
              </div>
            </div>
          </div>

          <div class="card pricing-card mb-4 box-shadow">
            <div class="card-body">
              <p class="pricing-card__title">Laboratory</p>
              <h1 class="card-title pricing-card__cost pb-3">
                £25
                <small class="text-muted">/ mo</small>
              </h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li class="list-divider">Location</li>
                <li class="checked">Pin a Location</li>
                <li class="checked">Modify a Location</li>

                <li class="list-divider">Circle</li>
                <li class="checked">Join a Circle</li>
                <li class="checked">Start a Circle</li>
                <li class="checked">Create a Campaign</li>

                <li class="list-divider">Media</li>
                <li class="checked">SMS</li>
                <li class="checked">Email</li>
                <li class="checked">IVR</li>
                <li class="unchecked">USSD</li>
                <li class="unchecked">Disbursement</li>

                <li class="list-divider">Other Services</li>
                <li class="checked">Volunteer</li>
                <li class="checked">Health Center/Medical</li>
                <li class="checked">Local Leaders</li>
              </ul>
              <div class="text-center">
                <a href="" class="btn btn-primary btn-lg d-inline">Get Started</a>
              </div>
            </div>
          </div>

          <div class="card pricing-card mb-4 box-shadow">
            <div class="card-body">
              <p class="pricing-card__title">Alchemist</p>
              <h1 class="card-title pricing-card__cost pb-3">
                £*
                <small class="text-muted">/ mo</small>
              </h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li class="list-divider">Location</li>
                <li class="checked">Pin a Location</li>
                <li class="checked">Modify a Location</li>

                <li class="list-divider">Circle</li>
                <li class="checked">Join a Circle</li>
                <li class="checked">Start a Circle</li>
                <li class="checked">Create a Campaign</li>

                <li class="list-divider">Media</li>
                <li class="checked">SMS</li>
                <li class="checked">Email</li>
                <li class="checked">IVR</li>
                <li class="checked">USSD</li>
                <li class="checked">Disbursement</li>

                <li class="list-divider">Other Services</li>
                <li class="checked">Volunteer</li>
                <li class="checked">Health Center/Medical</li>
                <li class="checked">Local Leaders</li>
              </ul>
              <div class="text-center">
                <a href="" class="btn btn-primary btn-lg d-inline">Contact Sales</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from "@/components/Landing/Nav/Nav.vue";
import Footer from "@/components/Landing/Footer/Footer.vue";

export default {
	name: "pricing",
	props: ["auth", "authenticated"],
	data() {
    return {
      authFlag: this.$props.authenticated
    };
  },
	components: {
    Nav,
    Footer
	}
}
</script>
<style scoped lang="scss" src="./Landing.scss"></style>